<div class="quoteparent clearfix">
  <div class="container">
    <div class="quote">
      <img [src]="myimage" href="quotestaticimg">
      <div class="quotecenter">
        <h3 id="randomans"></h3>
        <!-- <h5 id="authorz"></h5> -->
        <button class="quotebtn" (click)="getdataz()"> 
          <span>Give Me Advice!</span>
        </button>
      </div>
    </div>
    
  </div>
</div>